import { CommonAccountCompanyEntity } from "./CommonAccountCompanyEntity"

export interface CommonAccountEntity{
    id?: number | null,
    priority?: number | null,
    tempPriority?: number | null,
    consortiumCode?: string | null,
    vesselCode?: string | null,
    voyageCode?: string | null,
    serviceCode?: string | null,
    serviceCodeList?: string[] | null,
    soa?: string | null,
    etd?: Date | null,
    cntrStatus?: string | null,
    cntrStatusList?: string[] | null,
    subChargeType?: string | null,
    activeInd?: string | null,
    companyDetails: CommonAccountCompanyEntity[],
    shareType?: string | null,
    etb?: Date | null,  //update by betty

    [key: string]: string | boolean | null | Object | undefined
}

export const EMPTY_COMMON_ACCOUNT_ENTITY : CommonAccountEntity = {

    id: 0,
    priority: null,
    tempPriority: null,
    consortiumCode: '',
    vesselCode: '',
    voyageCode: '',
    serviceCode: '',
    serviceCodeList: [],
    soa: '',
    etd: null,
    etb: null,  //update by betty
    cntrStatus: '',
    cntrStatusList: [],
    activeInd: 'Y',
    shareType: "CommonAccountEntity",
    companyDetails: [],
}